const ERA_PARAM = 'filter.p.m.elohm.era';
const VALID_ERAS = new Set(['what_is', 'what_was']);
const READY_ATTRIBUTE = 'data-elohm-collection-index-ready';

function padIndex(value) {
  return String(value).padStart(2, '0');
}

function activeEra() {
  const era = new URL(window.location.href).searchParams.get(ERA_PARAM);
  return VALID_ERAS.has(era) ? era : '';
}

function setText(element, value) {
  if (element && element.textContent !== value) element.textContent = value;
}

function preserveEraInForms(root, era) {
  for (const form of root.querySelectorAll('form')) {
    let input = form.querySelector(`input[name="${ERA_PARAM}"]`);

    if (!era) {
      if (input?.hasAttribute('data-elohm-era-preserver')) input.remove();
      continue;
    }

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = ERA_PARAM;
      input.setAttribute('data-elohm-era-preserver', '');
      form.append(input);
    }

    if (input.getAttribute('value') !== era) input.setAttribute('value', era);
    if (input.value !== era) input.value = era;
  }
}

function syncCatalogIndex() {
  const root = document.querySelector('[data-elohm-catalog-root]');
  if (!root) return;

  const era = activeEra();
  const visibleCards = [...root.querySelectorAll('[data-elohm-era-product]')].filter((card) => !card.hidden);
  const total = visibleCards.length;
  const countLabel = `${total} OBJECT${total === 1 ? '' : 'S'}`;

  if (root.dataset.elohmActiveEra !== (era || 'all')) {
    root.dataset.elohmActiveEra = era || 'all';
  }

  for (const count of root.querySelectorAll('.products-count-wrapper span, [data-elohm-mobile-results-count]')) {
    setText(count, countLabel);
  }

  visibleCards.forEach((card, index) => {
    const number = padIndex(index + 1);
    const label = card.querySelector('.elohm-catalog-card__index');

    if (card.dataset.elohmCardNumber !== number) card.dataset.elohmCardNumber = number;
    if (card.dataset.elohmCardTotal !== String(total)) card.dataset.elohmCardTotal = String(total);
    setText(label, `${number} / ${total}`);
  });

  preserveEraInForms(root, era);
}

if (!document.documentElement.hasAttribute(READY_ATTRIBUTE)) {
  document.documentElement.setAttribute(READY_ATTRIBUTE, '');

  let frame = 0;
  const scheduleSync = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(syncCatalogIndex);
  };

  const start = () => {
    syncCatalogIndex();

    const scope = document.querySelector('main') || document.body;
    const observer = new MutationObserver(scheduleSync);
    observer.observe(scope, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['hidden'],
    });

    window.addEventListener('popstate', scheduleSync);
    document.addEventListener('shopify:section:load', scheduleSync);
    document.addEventListener('change', syncCatalogIndex, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}
